import React, { Component } from 'react'
import classnames from 'classnames'
import Newsletter from './Newsletter'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'

import './footer.css'
import axios from 'axios/index'

const API_URL = process.env.REACT_APP_API_PATH
const VENDOR_REST_BASE = process.env.REACT_APP_VENDOR_REST_BASE

class Footer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      newsletter: false,
      email: '',
      submitSuccess: false,
      successMessage: '',
      loading: false
    }

    this.toggleNewsletter = this.toggleNewsletter.bind(this)
    this.onEmailSubmit = this.onEmailSubmit.bind(this)
    this.onEmailInputChange = this.onEmailInputChange.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  toggleNewsletter (ev) {
    ev.preventDefault()
    const newsletter = !this.state.newsletter
    this.setState({
      newsletter
    })

    if (newsletter) {
      document.addEventListener('keydown', this.onKeydown, false)
    } else {
      this.setState({
        email: '',
        successMessage: '',
        submitSuccess: false
      })
      document.removeEventListener('keydown', this.onKeydown, false)
    }
  }

  // Hide newsletter when ESC is pressed
  onKeydown (ev) {
    if (ev.keyCode === 27) {
      this.toggleNewsletter(ev)
    }
  }

  onEmailInputChange (e) {
    this.setState({
      email: e.target.value
    })
  }

  onEmailSubmit (email) {
    this.setState({
      loading: true
    })

    const endpoint = `${API_URL}${VENDOR_REST_BASE}/mc/register?email=${encodeURIComponent(email)}`
    this.fetchSubmitEmail(endpoint)
  }

  fetchSubmitEmail (endpoint) {
    axios.get(endpoint)
      .then((response) => {
        this.setState({
          submitSuccess: true,
          successMessage: '"All places may be one, but that place is very big" -- Ly Twin Weedle',
          loading: false
        })
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            loading: false,
            successMessage: 'Something went wrong with your submission, please try again'
          })
        } else {
          this.setState({
            loading: false,
            successMessage: 'Something went wrong with your submission, please try again'
          })
        }
      })
  }

  render () {
    const col1 = ReactHtmlParser(this.props.first_column_text)
    const col2 = ReactHtmlParser(this.props.second_column_text)
    const col4 = ReactHtmlParser(this.props.fourth_column_text)
    const social = !this.props.social_icons ? false : this.props.social_icons.map((item, idx) => (
      <li key={idx}>
        <a
          href={item.url}
          target='_blank'
          rel='noopener noreferrer'>
          <span>{item.type.replace(/^\w/, c => c.toUpperCase())}</span>
        </a>
      </li>
    ))

    return (
      <footer className={classnames({
        'footer': true,
        'footer--newsletter': this.state.newsletter
      })}>
        <div className='container-fluid'>
          <div className='footer__inner'>
            <div className='row'>
              <div className='col-xs-12 col-sm-6'>
                <h4>Art & Mechanical</h4>
                <span className='footer__msg'>
                  {col1}
                </span>
                <span className='footer__copy hide--mobile'>
                  © 2018 Art & Mechanical
                  <span>|</span>
                  <Link to='/privacy-policy'>Privacy Policy</Link>
                </span>
              </div>
              <div className='col-xs-12 col-sm-6'>
                <div className='row'>
                  <div className='col-sm'>
                    <h4>Find Us</h4>
                    {col2}
                  </div>
                  <div className='col-sm'>
                    <h4>Connect</h4>
                    <ul>
                      {social}
                      <li>
                        <a href='#newsletter' onClick={this.toggleNewsletter}>
                          <span>Newsletter</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className='col-sm wysiwyg'>
                    <h4>New Business Enquiries</h4>
                    {col4}
                  </div>
                </div>
              </div>
              <div className='col-xs-12 show--mobile'>
                <span className='footer__copy'>
                  © 2018 Art & Mechanical
                  <span>|</span>
                  <Link to='/privacy-policy'>Privacy Policy</Link>
                </span>
              </div>
            </div>
          </div>
        </div>

        <Newsletter
          loading={this.state.loading}
          successMessage={this.state.successMessage}
          submitSuccess={this.state.submitSuccess}
          email={this.state.email}
          onInputChange={this.onEmailInputChange}
          submitHandler={this.onEmailSubmit}
          toggleNewsletter={this.toggleNewsletter}
        />
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js